import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';

export default function toggleElement( elementOrId, show, focus ) {
	if ( ! elementOrId ) {
		return;
	}

	let target, targetId;
	if ( typeof elementOrId === 'string' ) {
		targetId = elementOrId;
		target = document.getElementById( targetId );
	} else {
		target = elementOrId;
		targetId = target.id;
	}

	if ( ! target ) {
		return;
	}

	// Get the controls for this element
	const controls = document.querySelectorAll( `[aria-controls="${ targetId }"]` );

	if ( typeof show === 'undefined' || show === null ) {
		// Toggle based on target's hidden status
		show = target.getAttribute( 'aria-hidden' ) === 'true';
	}

	// Update the controls if applicable
	controls.forEach( control => {
		if ( control.hasAttribute( 'aria-expanded' ) ) {
			control.setAttribute( 'aria-expanded', show );
		}
		if ( control.hasAttribute( 'aria-selected' ) ) {
			control.tabIndex = show ? null : -1;
			control.setAttribute( 'aria-selected', show );
		}
	} );

	// Hide/show the target
	target.setAttribute( 'aria-hidden', ! show );
	if ( show && focus ) {
		// If target is meant to be focused (is tabble or has explicit tabindex)
		if ( target.tabIndex > 0 || target.hasAttribute( 'tabindex' ) ) {
			target.focus();
		} else {
			// Find the first focusable element within and focus that
			const focusable = [ ...target.querySelectorAll( FOCUSABLES_SELECTOR ) ].find( isElementFocusable );
			if ( focusable ) {
				focusable.focus();
			}
		}
	}

	return show;
}
